import React, {useState} from 'react';
import _ from "lodash";

const AssignProducts = (props) => {
    const {
        availableProducts   = [],
        productIds          = [],
        onChange            = (field, availableProducts) => {},
        disabled            = false,
        errors              = null,
    } = props;

    const getSelectAllValue = () => {
        return availableProducts.length === productIds.length;
    }

    const handleSelectAll = () => {
        const newProductIds = [];

        for (let i = 0; i < availableProducts.length; i++) {
            newProductIds.push(availableProducts[i].id);
        }

        onChange('product_ids', newProductIds);
    }

    const handleDeselectAll = () => {
        onChange('product_ids',[]);
    }

    const handleSelect = (product) => {
        const clone = _.cloneDeep(productIds);

        if (!clone.includes(product.id)) {
            clone.push(product.id);

            onChange('product_ids', clone);
        }
    }

    const handleReorder = (index, item, direction) => {
        let clone = _.cloneDeep(availableProducts);
        let indexA = index;
        let indexB = index;

        /**
         * Swap the line item order based on the previous position and the reorder direction.
         */
        if (direction === "up") {
            indexB = indexA - 1;
        } else if (direction === "down") {
            indexB = indexA + 1;
        }

        clone = swapElement(clone, indexA, indexB)

        for (let i = 0; i < clone.length; i++) {
            clone[i].order_index = i + 1;
        }
        onChange('order_index', clone);
    }

    const swapElement = (array, indexA, indexB) => {
        let tmp = array[indexA];
        array[indexA] = array[indexB];
        array[indexB] = tmp;
        return array;
    }

    const handleDeselect = (product) => {
        const clone = _.cloneDeep(productIds);

        if (clone.includes(product.id)) {
            let index = null;
            for (let i = 0; i < clone.length; i++) {
                if (clone[i] === product.id) {
                    index = i;
                }
            }

            clone.splice(index, 1);

            onChange('product_ids', [...clone]);
        }
    }

    const renderNoItems = () => {
        return (
            <div className={"product-row empty"}>
                <span>No Products</span>
            </div>
        )
    }

    const renderLineItemRow = (index, product, count) => {
        return (
            <div className={"product-row"} key={product.id}>
                <div className="column order-column">
                    <div className={"order-controls"}>
                        <div className={product.order_index === 1 ? "up disabled" : "up"}
                             onClick={() => !disabled ? handleReorder(index, product, "up") : {}}
                        >
                            <i className="fas fa-arrow-alt-up fa-fw" />
                        </div>
                        <div className={product.order_index === count ? "down disabled" : "down"}
                             onClick={() => !disabled ? handleReorder(index, product, "down") : {}}
                        >
                            <i className="fas fa-arrow-alt-down fa-fw" />
                        </div>
                    </div>
                </div>
                <div className="column checkbox-column">
                    <input
                        type="checkbox"
                        checked={productIds.includes(product.id)}
                        disabled={disabled}
                        onChange={() => productIds.includes(product.id) ? handleDeselect(product) : handleSelect(product)}
                    />
                </div>
                <div className="column ref-column">
                    <p className={"m-0"}>{product.reference}</p>
                </div>
                <div className="column name-column">
                    <p className={"m-0"}>{product.name}</p>
                </div>
                <div className="column quantity-column">
                    <p className={"m-0"}>{product.quantity}</p>
                </div>
                <div className="column price-column">
                    <p className={"m-0"}>{product.price}</p>
                </div>
            </div>
        );
    }

    const selectAll = getSelectAllValue();

    return (
        <React.Fragment>
            <div className={"m-0 mb-4 quote-products-table"}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
                    <div className={"h5 mb-0 text-eh-navy"}>
                        Select Products
                    </div>
                </div>
                {!!errors && !!errors.product_ids && (
                    <div className="invalid-feedback d-block mt-0 mb-3" role="alert">
                        <strong>
                            {errors.product_ids}
                        </strong>
                    </div>
                )}
                <div className={"product-table mb-3"}>
                    <div className="header">
                        <div className="column">

                        </div>
                        <div className="column checkbox-column">
                            <input
                                type="checkbox"
                                checked={selectAll}
                                disabled={disabled}
                                onChange={(event) => selectAll ? handleDeselectAll(event) : handleSelectAll(event)}
                            />
                        </div>
                        <div className="column ref-column">
                            <span>Product ref</span>
                        </div>
                        <div className="column name-column">
                            <span>Product name</span>
                        </div>
                        <div className="column quantity-column">
                            <span>Quantity</span>
                        </div>
                        <div className="column price-column">
                            <span>Price</span>
                        </div>
                    </div>
                    {!!availableProducts && availableProducts.length > 0 ? availableProducts.map((product, index) => renderLineItemRow(index, product, availableProducts.length)) : renderNoItems()}
                </div>
            </div>
        </React.Fragment>
    );
}

export default AssignProducts;
